import React from "react";
import PropTypes from "prop-types";
import JourneyTaskActionMenu from "../journey-task-action-menu";

const JourneyTaskRow = ({ journeyTask, handleEdit, handleDelete, journeyId }) => {
  const { description } = journeyTask;
  return (
    <div>
      <div>{description}</div>
      <JourneyTaskActionMenu
        journeyTask={journeyTask}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        type="threeDotMenu"
        journeyId={journeyId}
      />
    </div>
  );
};

JourneyTaskRow.propTypes = {
  journeyTask: PropTypes.object,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  journeyId: PropTypes.number,
};

JourneyTaskRow.defaultProps = {
  journeyTask: {},
  handleDelete: () => {},
  handleEdit: () => {},
  journeyId: null,
};

export default JourneyTaskRow;
